import React from 'react';
import { Gift, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface PromoPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PromoPopup: React.FC<PromoPopupProps> = ({ isOpen, onClose }) => {
    const { t, i18n } = useTranslation('home');
    const navigate = useNavigate();
    const isRtl = i18n.dir() === 'rtl';

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300">
            <div 
                className="bg-white rounded-3xl p-8 max-w-sm w-full relative shadow-2xl animate-in zoom-in-95 duration-500 flex flex-col items-center text-center"
                dir={isRtl ? 'rtl' : 'ltr'}
            >
                {/* Close Button */}
                <button 
                    onClick={onClose}
                    className="absolute top-4 end-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
                >
                    <X size={20} />
                </button>

                {/* Gift Icon with glow */}
                <div className="relative mb-6">
                    <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full scale-150 animate-pulse"></div>
                    <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center relative transform -rotate-6 hover:rotate-0 transition-transform">
                        <Gift size={40} className="text-primary" />
                    </div>
                </div>

                <h2 className="text-2xl font-black text-gray-900 mb-3 tracking-tight">
                    {t('promo.popupTitle', isRtl ? 'افتح خصمك الحصري! 🎁' : 'Unlock Your Exclusive Discount! 🎁')}
                </h2>
                
                <p className="text-gray-600 mb-8 leading-relaxed">
                    {t('promo.popupDesc', isRtl 
                        ? 'سجل الآن واحصل على كوبون خاص لطلبك الأول.' 
                        : 'Sign up now and get a special coupon for your first order.')}
                </p>

                <div className="flex flex-col w-full gap-3">
                    <button 
                        onClick={() => {
                            onClose();
                            navigate('/auth?mode=register');
                        }}
                        className="w-full bg-primary text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-primary/30 hover:scale-[1.02] active:scale-95 transition-all"
                    >
                        {t('promo.signUpNow', isRtl ? 'سجل الآن' : 'Sign Up Now')}
                    </button>
                    
                    <button 
                        onClick={onClose}
                        className="w-full py-3 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
                    >
                        {t('promo.maybeLater', isRtl ? 'ربما لاحقاً' : 'Maybe Later')}
                    </button>
                </div>
            </div>
        </div>
    );
};
